// extracted by mini-css-extract-plugin
module.exports = {"container":"AllContacts_container__1GtFP","addNew":"AllContacts_addNew__2RLuj","addNewIcon":"AllContacts_addNewIcon__2g_41","addNewText":"AllContacts_addNewText__1-Vxf"};